var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTools(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a-tool",
    fill: "currentColor",
    d: "M27 9.3q0-.55-.35-.9-.35-.4-.9-.4H4.25q-.55 0-.9.4-.35.35-.35.9v5.1q0 .5.35.85t.9.35H9.3v-1.2 1.2h11.4v-1.2 1.2H25.75q.55 0 .9-.35t.35-.85V9.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "b-tool",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.05,
    d: "M25.1 15.6v8.25q0 .85-.55 1.35-.55.6-1.35.6H6.8q-.75 0-1.35-.6-.6-.5-.6-1.35V15.6M10.6 8V5.5q0-.55.35-.9.35-.4.85-.4h6.35q.55 0 .9.4.35.35.35.9V8m1.3 10.2v-3.8M9.3 18.2v-3.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c-tool",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 1.05,
    d: "M19.4 8h6.35q.55 0 .9.4.35.35.35.9v5.1q0 .5-.35.85t-.9.35h-.65m-20.25 0h-.6q-.55 0-.9-.35T3 14.4V9.3q0-.55.35-.9.35-.4.9-.4H19.4m5.7 7.6H4.85"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a-tool"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b-tool"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c-tool"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTools);
export default __webpack_public_path__ + "static/media/icon-tools.659e66a111fc4b8f7f042864d47d4da0.svg";
export { ForwardRef as ReactComponent };